import { render, staticRenderFns } from "./ProntuarioNascimento.vue?vue&type=template&id=8a3820f4&"
import script from "./ProntuarioNascimento.vue?vue&type=script&lang=js&"
export * from "./ProntuarioNascimento.vue?vue&type=script&lang=js&"
import style0 from "./ProntuarioNascimento.vue?vue&type=style&index=0&id=8a3820f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports